@if (addedRolesSig(); as addedRoles) {
  <u>Roles</u> were added as
  <span class="ag-change-log-detail--new-value ms-2">{{ addedRoles }}</span>
}

@if (removedRolesSig(); as removedRoles) {
  <u>Roles</u> were removed:
  <span class="ag-change-log-detail--old-value ms-2">{{ removedRoles }}</span>
}

@if (updatedRolesSig(); as updatedRoles) {
  <u>Roles</u> were updated from
  <span class="ag-change-log-detail--old-value ms-2 me-2">{{ oldDataSig() }}</span> to
  <span class="ag-change-log-detail--new-value ms-2">{{ updatedRoles }}</span>
}
